var _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupRemoveBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.3536,
    y1: 2.35355,
    x2: 2.35355,
    y2: 10.3536,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupRemoveBlack);
export default __webpack_public_path__ + "static/media/GroupRemoveBlack.777d769e2e8369041c1c6c5523e3689e.svg";
export { ForwardRef as ReactComponent };